// @ts-expect-error VSCode does not like circular reference
type NestedObject = Record<string, NestedObjectValue>;
// @ts-expect-error VSCode does not like circular reference
type NestedObjectValue = string | Array<NestedObjectValue> | NestedObject;

const extractStringsFromObj = (obj: NestedObjectValue = {}): string[] =>
  typeof obj === 'string'
    ? obj
      ? [obj]
      : []
    : typeof obj === 'object'
    ? Object.keys(obj).flatMap(k => extractStringsFromObj(obj[k]))
    : [];

export default extractStringsFromObj;
